import { IconProps } from 'core/components/Icon/types'

/**
 * Actions
 */
export enum ActionTypes {
  VIEW_CHANGE_LAYOUT = 'VIEW_CHANGE_LAYOUT',
  VIEW_CHANGE = 'VIEW_CHANGE',
  VIEW_REMOVE_DATA = 'VIEW_REMOVE_DATA',
}

/**
 * View types
 */
export type TLayout = {
  auth?: {
    header?: {
      show?: boolean
    }
    footer?: {
      show?: boolean
    }
  }
  dash?: {
    header?: {
      title?: string
      icon?: IconProps
    }
  }
}

export type TView = {
  to: string
  from: string
}

/**
 * View Actions
 */
export type TChangeLayoutAction = {
  type: ActionTypes.VIEW_CHANGE_LAYOUT
  payload: TLayout
}

export type TChangeViewAction = {
  type: ActionTypes.VIEW_CHANGE
  payload: TView
}

export type TRemoveDataAction = {
  type: ActionTypes.VIEW_REMOVE_DATA
}

/**
 * Root State
 */
export type TState = {
  layout: TLayout
  view: TView
}

/**
 * Root Action
 */
export type TActionTypes =
  | TChangeLayoutAction
  | TChangeViewAction
  | TRemoveDataAction
